

// tslint:disable

import Vue from 'vue';
import SelectPicker from '@/components/SelectPicker.vue';

export type SimpleOption = string;

export type Option = {
	value: string;
	label?: string;
	title?: string|null;
	disabled?: boolean;
};
export type OptGroup = {
	label?: string;
	title?: string|null;
	disabled?: boolean;
	options: Array<string|Option>;
};

export type Options = Array<SimpleOption|Option|OptGroup>;

export default Vue.extend({
	components:	{
		SelectPicker,
	},
	props: {
		options: {
			type: Array as () => Option[],
			default: () => [] as Option[]
		},
		value: Array as () => string[]|null,
		textNoneSelected: {
			type: String,
			default: ''
		},
		textSelected: {
			type: String,
			default: ''
		},
	},
	computed: {
		optionsNotYetSelected(): Option[] {
			return this.options.filter(o => !this.selected.includes(o));
		},
		selected(): Option[] {
			const result = this.value?.map(v => this.options.find(o => (o as Option).value === v) as Option)
				.filter(v => v !== undefined) || [];
			return result;
		},
	},
	methods: {
		add(v: string) {
			const opt = this.options.find(o => (o as Option).value === v);
			if (opt) {
				const i = this.selected.indexOf(opt);
				if (i < 0) {
					// Not yet selected: add it at the end
					this.$emit('input', this.selected.concat([opt]).map(o => o.value));
				}
			}
		},
		clickLabel(target: EventTarget|null) {
			if (target && target instanceof HTMLElement) {
				const v = target.getAttribute('data-value') || target.innerText;
				this.remove(v);
			}
		},
		remove(v: string) {
			this.$emit('input', this.selected.filter(o => o.value !== v).map(o => o.value));
		},
	},
	data: () =>  ({
		selectValue: null as string|null,
	}),
	mounted() {
	},
	beforeDestroy() {
	},
});
